import React, {Component} from 'react';
import {Link, Redirect} from 'react-router-dom';
import AnchorLink from 'react-anchor-link-smooth-scroll'

import './Header.scss';

import GetIcon from '../GetIcon/GetIcon';

class Header extends Component {

  state = {
    redirect: false,
    redirectUrl: '/login',
    isMobileMenuOpen: false,
  };

  componentDidMount() {
  }

  closeMobileMenuHandler = (e) => {
    document.querySelector('.js-navigation-mobile-layout').classList.remove('_opened');
    document.querySelector('.js-navigation-mobile').classList.remove('_opened');
  }
  
  openMobileMenuHandler = (e) => {
    document.querySelector('.js-navigation-mobile-layout').classList.add('_opened');
    document.querySelector('.js-navigation-mobile').classList.add('_opened');
  }

  render() {
    let {className} = this.props;

    if (this.state.redirect) {
      return <Redirect to={this.state.redirectUrl}/>;
    }

    return (
        <header className="header">
          <div className="content-container content-container--header">
            <div className="header-logo-container">
              <AnchorLink className="header-logo-link" href="#intro" offset="60">
                <div className="header-logo-icon">
                  <GetIcon name="logo-unigine"/>
                </div>
              </AnchorLink>
            </div>

            <nav className="navigation">
              <ul className="navigation-list">
                {/* <li className="navigation-item"><AnchorLink href="#how-to-join" offset="60" className="navigation-link">how to join</AnchorLink></li> */}
                <li className="navigation-item"><AnchorLink href="#winners" offset="60" className="navigation-link">WINNERS</AnchorLink></li>
                {/* <li className="navigation-item"><AnchorLink href="#schedule" offset="60" className="navigation-link">SCHEDULE</AnchorLink></li> */}
                {/* <li className="navigation-item"><AnchorLink href="#ranking-and-winners" offset="60" className="navigation-link">RANKING & WINNERS</AnchorLink></li> */}
                {/* <li className="navigation-item"><AnchorLink href="#rules" offset="60" className="navigation-link">RULES</AnchorLink></li> */}
                {/* <li className="navigation-item"><AnchorLink href="#juri" offset="60" className="navigation-link">JURY</AnchorLink></li> */}
                <li className="navigation-item"><AnchorLink href="#contacts" offset="60" className="navigation-link">CONTACTS</AnchorLink></li>
                {/* <li className="navigation-item"><AnchorLink href="#faq" offset="60" className="navigation-link">FAQ</AnchorLink></li> */}
              </ul>
            </nav>

            <nav className="navigation-mobile js-navigation-mobile">
              <ul className="mobile-menu js-mobile-menu">
                {/* <li className="navigation-item">
                  <AnchorLink
                    href="#how-to-join"
                    offset="60"
                    className="navigation-link"
                    onClick={this.closeMobileMenuHandler}
                  >how to join</AnchorLink>
                </li> */}

                <li className="navigation-item">
                  <AnchorLink
                    href="#winners"
                    offset="60"
                    className="navigation-link"
                    onClick={this.closeMobileMenuHandler}
                  >WINNERS</AnchorLink>
                </li>

                {/* <li className="navigation-item">
                  <AnchorLink
                    href="#schedule"
                    offset="60"
                    className="navigation-link"
                    onClick={this.closeMobileMenuHandler}
                  >SCHEDULE</AnchorLink>
                </li> */}

                {/* <li className="navigation-item">
                  <AnchorLink
                    href="#ranking-and-winners"
                    offset="60"
                    className="navigation-link"
                    onClick={this.closeMobileMenuHandler}
                  >RANKING & WINNERS</AnchorLink>
                </li> */}

                {/* <li className="navigation-item">
                  <AnchorLink
                    href="#rules"
                    offset="60"
                    className="navigation-link"
                    onClick={this.closeMobileMenuHandler}
                  >RULES</AnchorLink>
                </li> */}

                {/* <li className="navigation-item">
                  <AnchorLink
                    href="#juri"
                    offset="60"
                    className="navigation-link"
                    onClick={this.closeMobileMenuHandler}
                  >JURY</AnchorLink>
                </li> */}

                <li className="navigation-item">
                  <AnchorLink
                    href="#contacts"
                    offset="60"
                    className="navigation-link"
                    onClick={this.closeMobileMenuHandler}
                  >CONTACTS</AnchorLink>
                </li>

                {/* <li className="navigation-item">
                  <AnchorLink
                    href="#faq"
                    offset="60"
                    className="navigation-link"
                    onClick={this.closeMobileMenuHandler}
                  >FAQ</AnchorLink>
                </li> */}
              </ul>

              <button className="js-close-button mobile-close-button" onClick={this.closeMobileMenuHandler}>
                <GetIcon name="close"/>
              </button>
            </nav>

            <div className="navigation-mobile-layout js-navigation-mobile-layout" onClick={this.closeMobileMenuHandler}></div>

            <div className="header-registeration">
              <a href="https://unigine.com/?sign-up-for-news=true#news" offset="60" className="header-registeration-button"><span className="header-registeration-button-text-desktop">SUBSCRIBE</span><span className="header-registeration-button-text-mobile">SUBSCRIBE</span></a>
            </div>

            <div className="header-burger-container">
              <button className="header-menu-icon js-menu-icon-open" onClick={this.openMobileMenuHandler}>
                <GetIcon name="menu"/>
              </button>
            </div>
          </div>
        </header>

    );
  }
}

export default Header;
